import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L13 13M13 1L1 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgCloseIcon;
